import { TranslateService } from './translate/Translate';
import { NameIdxService } from './nameidx/NameIdx';

export const AdminApi = {
    ...TranslateService,
    ...NameIdxService
}